import Service, { service, type Registry as Services } from '@ember/service';
import type Store from '@ember-data/store';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import type { TaskPriority } from 'uplisting-frontend/models/task';
import type { IErrorResult } from 'uplisting-frontend/services/http-client';

export interface IDamageReportPhoto {
  bucket: string;
  key: string;
}

export interface IDamageReportDraft {
  title: string;
  description?: string;
  priority?: TaskPriority;
  photos: IDamageReportPhoto[];
}

export default class TaskDamageReportRepositoryService extends Service {
  @service store!: Store;

  @service httpClient!: Services['http-client'];

  public async report(
    task: ModelRegistry['task'],
    draft: IDamageReportDraft,
  ): Promise<ModelRegistry['task']> {
    const payload = await this.httpClient.postJSONApi<object>(
      'v2/task_damage_reports',
      {
        attributes: {
          title: draft.title,
          description: draft.description,
          priority: draft.priority,
          photos: draft.photos,
        },
        relationships: { task: { data: { id: task.id } } },
      },
    );

    if (!payload || (payload as IErrorResult).isError) {
      throw new Error('damage report could not be filed');
    }

    this.store.pushPayload(payload);

    const reportId = (payload as { data?: { id?: string } }).data?.id;

    return this.store.peekRecord(
      'task',
      reportId as string,
    ) as ModelRegistry['task'];
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/task-damage-report': TaskDamageReportRepositoryService;
  }
}
